<app-engagement-table
  [loading]="loading"
  [eventSearchType]="EventSearchType.AllEvents"></app-engagement-table>
